import { API } from "../urls";

/**
 * Ek modül uçları (V98).
 *
 * Desen `subscription-requests.js` ile aynıdır: fetch + credentials:"include",
 * hata durumunda backend mesajı fırlatılır. Satın alma ucu ise ham `Response`
 * döner — backend başarıda PayTR'nin 3D HTML formunu, hatada JSON gönderdiği
 * için gövdeyi çağıran taraf içerik tipine bakarak çözmek zorunda
 * (abonelik akışındaki `initiate3DSPayment` ile birebir aynı gerekçe).
 */

const getHeaders = () => ({ "Content-Type": "application/json" });
const fetchOpts = { credentials: "include" };

// ─── FİRMA TARAFI ────────────────────────────────────────────

/** Satın alınabilir modüller (aktif + vitrinde görünen). */
export const getPurchasableAddons = async () => {
    const res = await fetch(API.addon_modules, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Ek modüller yüklenemedi");
    return res.json();
};

/** Firmanın kendi modülleri — süresi dolmuş ve iptal edilenler dâhil. */
export const getMyAddons = async () => {
    const res = await fetch(API.addon_mine, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Modülleriniz yüklenemedi");
    return res.json();
};

/**
 * Satın almayı başlatır. Ham `Response` döner; başarıda gövde PayTR'nin
 * HTML formudur, hatada JSON'dur.
 */
export const initiateAddonPurchase = async (payload) => {
    return fetch(API.addon_purchase, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
};

/**
 * Satın alma durumu. 3D dönüşünde açılan sayfa bunu yoklar: PayTR'nin
 * callback'i kullanıcı tarayıcıya döndükten saniyeler sonra gelebilir.
 */
export const getAddonPurchaseStatus = async (merchantOid) => {
    const res = await fetch(API.addon_purchase_status(merchantOid), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Satın alma durumu alınamadı");
    return res.json();
};

// ─── SÜPER ADMIN ─────────────────────────────────────────────

export const adminGetAddonModules = async () => {
    const res = await fetch(API.admin_addon_modules, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Modüller yüklenemedi");
    return res.json();
};

export const adminGetAddonModule = async (id) => {
    const res = await fetch(API.admin_addon_module(id), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Modül yüklenemedi");
    return res.json();
};

export const adminCreateAddonModule = async (payload) => {
    const res = await fetch(API.admin_addon_modules, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Modül oluşturulamadı");
    return res.json();
};

export const adminUpdateAddonModule = async (id, payload) => {
    const res = await fetch(API.admin_addon_module(id), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Modül güncellenemedi");
    return res.json();
};

/** Satılmış modül silinemez; backend 409 ve ne yapılacağını söyleyen mesaj döner. */
export const adminDeleteAddonModule = async (id) => {
    const res = await fetch(API.admin_addon_module(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Modül silinemedi");
    return res.json();
};

/** Modül formunun özellik listesi — paket formuyla aynı katalogdan okur. */
export const adminGetAddonFeatures = async () => {
    const res = await fetch(API.admin_addon_features, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Özellik listesi yüklenemedi");
    return res.json();
};

export const adminGetCompanyAddons = async (companyId) => {
    const res = await fetch(API.admin_addon_company(companyId), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Firma modülleri yüklenemedi");
    return res.json();
};

/** Ücretsiz tanımlama. Atayan kullanıcı token'dan okunur, gövdede gönderilmez. */
export const adminAssignAddon = async (payload) => {
    const res = await fetch(API.admin_addon_assign, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Modül tanımlanamadı");
    return res.json();
};

/** İptal kaydı silmez, gerekçesiyle saklar; para iadesi yapmaz. */
export const adminCancelCompanyAddon = async (id, reason) => {
    const res = await fetch(API.admin_addon_cancel(id), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ reason: reason || null }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Modül iptal edilemedi");
    return res.json();
};
